export default "__VITE_ASSET__D1tr6gBd__"